import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Screen, Section, InformationBox } from '../components/generic/View'
import Markdown from '../components/generic/Markdown'
import PreparedHelmet from '../components/seo/PreparedHelmet'
const Imprint = () => {
  const { t } = useTranslation()
  const [MDContent, setMDContent] = useState('')

  // Fetch MD file
  useEffect(() => {
    import('../../markdown/imprint.md')
      .then(res => {
        fetch(res.default)
          .then(res => res.text())
          .then(res => setMDContent(res))
          .catch(err => console.log(err))
      })
      .catch(err => console.log(err))
  })

  const header = {
    type: 'menu',
    withBackground: true,
    withoutMenu: true,
    logoLinkLeadsToIndex: true
  }

  return (
    <>
      <PreparedHelmet
        title={t('general.imprint')}
        description={t('memory_room.landing_text')}
        titleHasAppName={true}
      />

      <Screen header={header}>
        <Section columnItem textAlign="left">
          <InformationBox>
            <Markdown>{MDContent}</Markdown>
          </InformationBox>
        </Section>
      </Screen>
    </>
  )
}

export default Imprint
